import {svgIconWrapper} from '../svg-icon-wrapper';

import WordpressRegular from './wordpress-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <WordpressRegular {...rest} />;
}

SvgComponent.iconName = 'wordpressRegular';

export const WordpressRegularIcon = svgIconWrapper(SvgComponent);
